import { apiGet } from './api';
import API_CONFIG from '../config/api';

const { ENDPOINTS } = API_CONFIG;

export const DashboardService = {
  async getStats() {
    const response = await apiGet(ENDPOINTS.ADMIN.STATS);
    const data = await response.json();
    if (!data.success) {
      throw new Error(data.error || 'Error al cargar estadísticas');
    }
    return data.data;
  }
};
